import { setActionableAlert, setAlertMode, setMessage, setShowAlert } from "./Alert/alert.slice"
import store from "./store"

export const showMessageOnFailure = (message: string) => {
    return () => {
        store.dispatch(setActionableAlert(false))
        if (typeof message === 'string') {
            store.dispatch(setMessage(message))
            store.dispatch(setAlertMode(false))
            store.dispatch(setShowAlert(true))
            console.log('logging ', message);
        }
    }
}